/*#########################################################
    フォーム変更時の計算
#########################################################*/

const form = (document.querySelector('.culc-item')) ? document.querySelector('.culc-item').closest('form') : null;
const items = (form && form.querySelectorAll('.culc-item')) ? form.querySelectorAll('.culc-item') : null;
const item = (form && form.querySelector('[name="id"]')) ? form.querySelector('[name="id"]').value : null;
const postages = (document.querySelector('[data-postage]')) ? document.querySelectorAll('[data-postage]') : null;
window.addEventListener('DOMContentLoaded', function () {
    if (items) {
        items.forEach(item => {
            item.addEventListener('change', (event) => {
                cart.getSelected();
            });
        });
    }
    // ご注文内容 > 発送方法の選択肢取得
    if (postages) {
        postages.forEach(postage => {
            postage.addEventListener('change', (event) => {
                cart.setPostage(postage);
            });
            if (postage.checked) {
                cart.setPostage(postage);
                section_toggle(postage);
            }
        });
    }
});

module.exports = {
    // 選択値の取得
    getSelected() {
        // [...hoge] => スプレッド構文
        // https://developer.mozilla.org/ja/docs/Web/JavaScript/Reference/Operators/Spread_syntax
        let datas = [...items].map(function ($item) {
            let text = null;
            if ($item.tagName == 'SELECT') {
                text = $item[$item.selectedIndex].text;
            } else if ($item.tagName == 'INPUT') {
                text = $item.value;
            }
            return {
                'id': $item.id,
                'name': $item.name,
                'value': $item.value,
                'text': text
            };
        });
        return cart.get_data(datas);
    },
    // 取得
    get_data(datas) {
        // ボタンをローディング状態にする
        loading("計算中...");
        let api_url = false;
        let formdata = new FormData(form);
        let callback = cart.culc;
        let e_callback = loaded; // 失敗した時もローディングを解除
        if (item == "dojin") {
            api_url = "/api/items/dojin";
        }
        let data = api({
            api: api_url,
            _method: "GET",
            formdata,
            callback,
            e_callback
        });
        return datas;
    },
    culc(data) {
        // 綴じ方によって、ページ数の増減値を変更
        const $page_num = form.querySelector('#page_num');
        const page_num = data.posts.page_num.value; // サーバからの返却値
        const $page_num_spans = $page_num.querySelectorAll('span');
        for(let i = 0; i < $page_num_spans.length; i++){
            _unwrap($page_num_spans[i]); // spanを削除
        }
        const $page_num_options = $page_num.querySelectorAll('option');
        if (data.posts.binding.binding == "saddle_stitch") { //中綴じ
            for(let i = 0; i < $page_num_options.length; i++){
                // 4で割り切れない場合は、optionをspanで囲む
                if ($page_num_options[i].value % 4 != 0 || $page_num_options[i].value > 32) {
                    _wrap($page_num_options[i], document.createElement("span"));
                }
            }
        }else{ //無縁綴じ
            for(let i = 0; i < $page_num_options.length; i++){
                if ($page_num_options[i].value < 20 ) {
                    _wrap($page_num_options[i], document.createElement("span"));
                }
            }
        }
        $page_num.querySelector(`option[value="${page_num}"]`).selected = true; // サーバからの返却値を選択値とする

        // 遊び紙が選択されている場合、遊び紙カラーを表示
        const $flyleaf_color = form.querySelector('#flyleaf_color');
        if (data.posts.flyleaf.id == 1) { //遊び紙なし
            for (const element of document.getElementsByName('flyleaf_color')) {
                element.checked = false;
            }
            $flyleaf_color.style.display ="none";
        }else{
            $flyleaf_color.style.display ="block";
        }

        // 表紙の紙質によって、表紙の表面加工方法を変更
        const $cover_processing = form.querySelector('#cover_processing');
        const cover_processing = data.posts.cover_processing.id; // サーバからの返却値
        const $cover_processing_spans = $cover_processing.querySelectorAll('span');
        for(let i = 0; i < $cover_processing_spans.length; i++){
            _unwrap($cover_processing_spans[i]); // spanを削除
        }
        const $cover_processing_options = $cover_processing.querySelectorAll('option');
        if (data.posts.cover_paper.is_not_pp == 1) { //PP加工非対応の場合
            for(let i = 0; i < $cover_processing_options.length; i++){
                if ($cover_processing_options[i].value !=  1 ) {
                    _wrap($cover_processing_options[i], document.createElement("span"));
                }
            }
        }
        $cover_processing.querySelector(`option[value="${cover_processing}"]`).selected = true; // サーバからの返却値を選択値とする

        // 返却値に印刷方法が含まれている場合
        if (data.posts.print.id) {
            // name=printのnodelistを取得し、valueがpostと一致するものを選択状態にする
            Array.from(form.print).find(print_radio => print_radio.value == data.posts.print.id).checked = true;
            // クリックされた印刷方法によって値段の色を変更
            if (data.posts.print.id == 1) {
                document.querySelector('[data-name="price_ondemand"]').style.color = "red";
                document.querySelector('[data-name^="price_offset"]').style.removeProperty('color');
            } else {
                document.querySelector('[data-name="price_offset"]').style.color = "red";
                document.querySelector('[data-name^="price_ondemand"]').style.removeProperty('color');
            }
        }
        const posts = data.posts;
        // 注文内容の表示
        Object.keys(posts).forEach(key => {
            document.querySelectorAll('[data-name="' + key + '"]').forEach(
                element => element.textContent = posts[key].text
            );
        });
        // ボタンのローディング状態を解除
        loaded();
    },
    selected_payment(id) {
        document.querySelectorAll('.input_payment').forEach(
            element => element.style.display = "none"
        );
        document.querySelector('#input_payment_' + id).style.display = "block";
    },
    // 定休日の取得
    get_shipping_date(target = null, working_days) {
        let formdata = new FormData();
        formdata.append("target", target);
        formdata.append("working_days", working_days);
        api({
            api: "/api/holidays",
            _method: "GET",
            formdata,
            callback: cart.set_shipping_date,
            e_callback: null
        });
    },
    set_shipping_date(data) {
        const target = (isset(data.request) && isset(data.request.target)) ? data.request.target : null;
        const input = (document.querySelector(target)) ? document.querySelector(target) : null;
        flatpickr(input, {
            minDate: data.start_date,
            maxDate: data.end_date,
            disable: data.holidays,
        });
    },
    setPostage($input) {
        // 送料の取得
        const postage = parseFloat($input.getAttribute('data-postage'));
        // 商品の小計の取得
        const subtotal = parseFloat(document.querySelector('[data-col="subtotal"]').textContent.replace(/\D/g, ''));
        // 送料の表示
        document.querySelector('[data-col="postage"]').textContent = toLocaleNum(postage);
        // 合計の表示
        document.querySelector('[data-col="invoice_amount"]').textContent = toLocaleNum(postage + subtotal);
    },
    // 見積書の表示
    async showEstimate() {
        if (item == "dojin") {
            let posts = Object.fromEntries(new FormData(form));
            posts._method = "POST";
            execPost({
                action: "/pdf/estimate",
                data: posts,
                target: "_blank"
            });
        }
    },
}


